/* global BX24 */
import { useEffect } from "react";

const Bitrix = ({ setDealId }) => {
  // Проверяем, запущено ли приложение в Битрикс24
  useEffect(() => {
    if (typeof BX24 === "undefined") {
      console.warn("⚠️ BX24 API не загружен. Приложение работает вне Bitrix24.");
      return; // Выход, если не Bitrix
    }
  
    console.log("✅ Инициализация BX24...");
    try {
      BX24.init(() => {
        console.log("✅ BX24 API успешно инициализирован.");
        const placementInfo = BX24.placement?.info?.();
        console.log("📌 placementInfo:", placementInfo);
  
        if (placementInfo?.options?.ID) {
          const bxDealId = placementInfo.options.ID.toString();
          console.log("✅ ID сделки:", bxDealId);
          setDealId(bxDealId);
          BX24.fitWindow();
        } else {
          console.warn("❌ Не удалось получить ID сделки.");
        }
      });
    } catch (error) {
      console.warn("⚠️ Ошибка инициализации BX24 API:", error);
    }
  }, [setDealId]);

  return null; // Компонент не рендерит ничего, только передает данные в родительский компонент
};

export default Bitrix;
